import React, { Component } from "react";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar.js";
import Select from "react-select";
import { tokens, alert, select_style, toFixed, GET, POST, format_date, float, validate, DatePicker, NumberZero, getStorage, loading } from "../../components/CustomComponent.js";

const select_role = getStorage("role_detail")?.find((item) => item.name === "record-other")?.role || [];
const view_r = select_role[0] === 1;
const create_r = select_role[1] === 1;

export default class RecordBill extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => {
    const d = new Date();
    return {
      data_customer: [], customer_id: "", address_number: null,
      record_date: d, record_time: `${NumberZero(d.getHours())}:${NumberZero(d.getMinutes())}`,
      iw_number: format_date(d, "yymmddhh:mm:ss").replace(/:/g, ""),
      full_name: "", project_name: "", address: "", title: "", cost: "", total_amount: 0.0,
      receipt_id: "", remark: "", full_name_print: "", position_name: ""
    };
  };

  async componentDidMount() {
    loading(false); // ปิด loading ทันทีที่เข้ามาหน้าแรกตามต้องการ
    if (view_r) {
      loading(true);
      await Promise.all([this.GetPDFReceipt(), this.GetCustomerAll()]);
      loading(false);
    }
  }

  GetCustomerAll = async () => {
    const res = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (res?.status) {
      this.setState({ data_customer: res.data.data.map(item => ({ ...item, value: item.customer_id, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) });
    }
  };

  GetPDFReceipt = async () => {
    const res = await GET(tokens, `v1/TH/document-manage/detail/receipt/${getStorage("receipt_id")}`);
    if (res?.status) {
      const { receipt_id, remark, full_name, position_name } = res.data.data;
      this.setState({ receipt_id, remark, full_name_print: full_name, position_name });
    }
  };

  Create = async () => {
    loading(true);
    const { record_date, record_time, iw_number, full_name, project_name, address, title, cost, total_amount, address_number } = this.state;
    
    const payload = {
      record_date: new Date(record_date).toISOString().split("T")[0], record_time, iw_number,
      full_name, agency_name: project_name, address_number: address,
      record_other_list: [{ title, cost: Number(cost) }], total_amount
    };

    const res = await POST(tokens, `v1/TH/record-other/create/${getStorage("project_id")}`, payload);
    
    if (res?.status) {
      alert("success", "สำเร็จ", `บันทึกใบแจ้งหนี้หมายเลข "${iw_number}" สำเร็จแล้ว`, "/record-other");
      
      localStorage.setItem("DATA_", JSON.stringify({
        project_name: getStorage("project_name"),
        project_address: `เลขที่ ${getStorage("project_address")}\nเบอร์โทรติดต่อ ${getStorage("phone_number")} เลขที่ผู้เสียภาษี ${getStorage("tax_number")}`,
        cutomer_name: full_name, cutomer_address: address || address_number?.address_number,
        number: iw_number, date: format_date(record_date, "dd mmmm yyyy"), payment_date: format_date(record_date, "dd mmmm yyyy"),
        title, cost, total: cost, change_satang: 0,
      }));
      
      window.open("/doc/invoice-other", "_blank");
      this.setState(this.getInitialState());
    }
    loading(false);
  };

  // Helper สำหรับจัดการ Text input แบบสั้นลง
  handleTextChange = (field) => (e) => this.setState({ [field]: e.target.value, customer_id: "", address_number: null });

  render() {
    const { iw_number, data_customer, address_number, record_date, record_time, full_name, project_name, address, title, cost, total_amount } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ออกใบแจ้งหนี้อื่นๆ" />
        <div className="body">
          <div className="p-3">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h4 className="mb-0"><b>ออกใบแจ้งหนี้อื่นๆ เลขที่ใบแจ้งหนี้ : {iw_number || "-"}</b></h4>
            <button className="btn btn-outline-primary px-4 mx-1" onClick={() => window.location.href = "/record-bill-history"}>รายการทั้งหมด</button>
          </div>

          <div className="card border-0 px-3 pt-3 mb-3">
            <div className="row">
              <div className="col-12 col-lg-4 col-xl-3 mb-3">
                <label>บ้านเลขที่</label>
                <Select
                  className="bg-contain border-0 select-search w-100" styles={select_style}
                  options={data_customer} value={address_number}
                  onChange={(e) => this.setState({ customer_id: e.customer_id, full_name: e.full_name, project_name: e.project_name, address: e.address || e.address_number, address_number: e })}
                />
              </div>
              <div className="col-6 col-md-4 mb-3"><label>วันที่</label><DatePicker className="form-control bg-contain border-0" value={record_date} disabled /></div>
              <div className="col-6 col-md-4 mb-3"><label>เวลา</label><input type="time" className="form-control bg-contain border-0" value={record_time} disabled /></div>
              <div className="col-12 col-md-4 mb-3"><label>ชื่อ-นามสกุล</label><input type="text" className="form-control bg-contain border-0" value={full_name} onChange={this.handleTextChange("full_name")} /></div>
              <div className="col-12 col-md-4 mb-3"><label>ชื่อหน่วยงาน</label><input type="text" className="form-control bg-contain border-0" value={project_name} onChange={this.handleTextChange("project_name")} /></div>
              <div className="col-12 col-md-4 mb-3"><label>ที่อยู่</label><input type="text" className="form-control bg-contain border-0" value={address} onChange={this.handleTextChange("address")} /></div>
            </div>
          </div>

          <div className="card border-0 p-3 mb-3">
            <table className="table table-borderless table-striped mb-0">
              <thead>
                <tr className="bg-dark-blue text-white"><th className="text-center">รายการ</th><th className="text-right wpx-200">ราคารวมสุทธิ</th></tr>
              </thead>
              <tbody>
                <tr>
                  <td><input type="text" className="form-control" value={title} onChange={(e) => this.setState({ title: e.target.value })} /></td>
                  <td><input type="text" className="form-control" value={cost} maxLength={11} onChange={(e) => float(e.target.value) && this.setState({ cost: e.target.value, total_amount: Number(e.target.value) })} /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="card border-0 p-3 mb-3 d-flex flex-row justify-content-between">
            <b>จัดเก็บเงินทั้งสิ้น</b> <b>฿{toFixed(total_amount)}</b>
          </div>

          {create_r && (
            <button 
              className="btn btn-outline-primary bg-white w-100 mb-4" 
              onClick={() => !validate(this.state, ["full_name", "project_name", "address", "title", "cost"]) && this.Create()}
            >
              พิมพ์ใบเสร็จ
            </button>
          )}
          </div>
        </div>
      </div>
    );
  }
}